import { createClient } from "./requests.js";
let token = "";
// ==================== READ ====================

function getUSPatentApplication(id) {
  const request = createClient(token);
  return request.get(`/application?id=${id}`);
}

function getIssuedPatentMaintenanceData(applId, patentNum) {
  const request = createClient(token);
  return request.get(
    `/application/maintenance?applicationNumber=${applId}&patentNumber=${patentNum}`
  );
}

function getUSPatAppbyCustNum(custnum, start = 0) {
  const request = createClient(token);
  return request.get(
    `/application/customer-number?id=${custnum}&start=${start}`
  ).catch((error) => {
    console.log("error in get pat app by custom " + error);
    return null;
  });
}

function getUSPatentApplicationCmsData(id) {
  const request = createClient(token);
  return request.get(`/application/cmsData?id=${id}`).catch((error) => {
    console.log("error in get cms " + error);
    return null;
  });
}

function getUSPatentApplicationIfwData(id) {
  const request = createClient(token);
  return request.get(`/application/ifw?id=${id}`).catch((error) => {
    console.log("error in get ifw data " + error);
    return null;
  });
}

function downloadDocument(firm_id, applId, docId) {
  const request = createClient(token);
  return request.get(`/download/pdf?firm_id=${firm_id}&id=${applId}&docId=${docId}`);
}

function downloadDocumentByDownloadUrl(firm_id, applId, downloadUrl) {
  const request = createClient(token);
  return request.post("/download/document", {
    firm_id: firm_id,
    id: applId,
    downloadUrl: downloadUrl,
  });
}

function enqueuePrivatePair(firm_id, customer_number) {
  const request = createClient(token);
  return request.post("/ppair", {
    customer_number: customer_number,
    firm_id: firm_id,
  });
}

function enqueuePrivatePairPatent(firm_id, patent_number) {
  const request = createClient(token);
  return request.post("/ppair", {
    patent_number: patent_number,
    firm_id: firm_id,
  });
}

function sendInvites(firm_id) {
  const request = createClient(token);
  return request.post("/invites/send_invites", {
    firm_id: firm_id,
  });
}

function acceptInvite(invite_id, firm_id) {
  const request = createClient(token);
  return request.post("/invites/accept_invite", {
    invitation_id: invite_id,
    firm_id: firm_id,
  });
}

function countPendingPatents(customer_numbers) {
  const request = createClient(token);
  return request.get("/customerNumberCount", { params: { customerNumbers: customer_numbers }});
}

function sendXml(firm_id, xml_data) {
  const request = createClient(token);
  return request.post("/xmlImport", {firm_id: firm_id, xml_data: xml_data});
}

function addLLM(firm_id, llm_name, llm_api_key) {
  const request = createClient(token);
  return request.post("/llm-setup/add-llm", {firm_id: firm_id, llm_name: llm_name, llm_api_key: llm_api_key});
}

function deleteLLM(firm_id, llm_name) {
  const request = createClient(token);
  return request.post("/llm-setup/delete-llm", {firm_id: firm_id, llm_name: llm_name});
}

function getReferencesAndCitations(firm_id, document_id, xml_data) {
  const request = createClient(token);
  return request.post("/office-action/getReferencesAndCitations", {firm_id: firm_id, document_id: document_id, xml_data: xml_data});
}

function generateClaimChart(firm_id, document_id, xml_data) {
  const request = createClient(token);
  return request.post("/office-action/generateClaimChart", {
    firm_id: firm_id,
    document_id: document_id,
    xml_data: xml_data,
  });
}

function getClaimChart(firm_id, document_id) {
  const request = createClient(token);
  return request.get("/office-action/claimChart", {
    params: { firm_id: firm_id, document_id: document_id },
  });
}

function updateClaimChartRow(firm_id, document_id, rowId, updates) {
  const request = createClient(token);
  const body = { firm_id: firm_id, document_id: document_id };
  if (Object.prototype.hasOwnProperty.call(updates, "gapNote")) {
    body.gapNote = updates.gapNote;
  }
  if (Object.prototype.hasOwnProperty.call(updates, "status")) {
    body.status = updates.status;
  }
  return request.patch(
    `/office-action/claimChart/${encodeURIComponent(rowId)}`,
    body
  );
}

function verifyClaimChartCitation(firm_id, document_id, rowId, referenceNumber) {
  const request = createClient(token);
  return request.post(
    `/office-action/claimChart/${encodeURIComponent(rowId)}/verifyCitation`,
    {
      firm_id: firm_id,
      document_id: document_id,
      referenceNumber: referenceNumber,
    }
  );
}

function draftOAResponse(summary, explanation, firm_id, document_id) {
  const request = createClient(token);
  return request.post("/office-action/analyze", {
    firm_id: firm_id,
    document_id: document_id,
    summary: summary,
    explanation: explanation,
  });
}

function streamOAAnalysis(firm_id, document_id, options = {}) {
  const request = createClient(token);
  return request.postEventStream("/office-action/stream", {
    firm_id: firm_id,
    document_id: document_id
  }, options);
}

function oaChat(firm_id, document_id, chat_history_id, user_prompt, system_instruction, llm_name, llm_model, context = [], options = {}) {
  const request = createClient(token);
  console.log("Sending OA chat request with context:", context);
  return request.postEventStream("/office-action/chat", {
    firm_id: firm_id,
    document_id: document_id,
    session_id: token,
    chat_history_id: chat_history_id,
    user_prompt: user_prompt,
    system_instruction: system_instruction,
    llm_name: llm_name,
    llm_model: llm_model,
    context: context,
  }, options);
}

function parseIdsPdf(firm_id, applId, storagePath) {
  const request = createClient(token);
  return request.post("/ids/parse-ids-pdf", {
    firm_id: firm_id,
    applId: applId,
    storagePath: storagePath,
  });
}

function parseOaPdf(firm_id, applId, file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("firm_id", firm_id);
  formData.append("applId", applId);
  const request = createClient(token);
  return request.post("/ids/parse-oa-pdf", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function parseClaimsPdf(firm_id, file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("firm_id", firm_id);
  const request = createClient(token);
  return request.post("/office-action/parse-claims-pdf", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function downloadIdsReference(firm_id, reference_id, pdfUrl) {
  const request = createClient(token);
  return request.post("/ids/download-reference", { firm_id, reference_id, pdfUrl });
}

function parseRefPdfs(firm_id, applId, files) {
  const formData = new FormData();
  for (const file of files) {
    formData.append("files", file);
  }
  formData.append("firm_id", firm_id);
  formData.append("applId", applId);
  const request = createClient(token);
  return request.post("/ids/parse-ref-pdfs", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function lookupReferences(firm_id, applId, referenceNumbers) {
  const request = createClient(token);
  return request.post("/ids/lookup-references", {
    firm_id,
    applId,
    reference_numbers: referenceNumbers,
  });
}

function downloadReference(firm_id, document_id, patent_number) {
  const request = createClient(token);
  return request.post("/office-action/getReferenceByPatentNumber", {firm_id: firm_id, document_id: document_id, patent_number: patent_number});
}

function uploadReferencePdf(firm_id, document_id, reference_id, file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("firm_id", firm_id);
  formData.append("document_id", document_id);
  formData.append("reference_id", reference_id);
  const request = createClient(token);
  return request.post("/upload/uploadReferencePdf", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function setAuthToken(id) {
  token = id;
}

// Patensys v2: currently only changeSubscription is used.
function cancelSubscription(sub_id, firm_id) {
  const request = createClient(token);
  return request.post("/changeSubscription/cancel", {subId: sub_id, firmId: firm_id});
}

function changeSubscription(sub_id, firm_id, items) {
  const request = createClient(token);
  return request.post("/changeSubscription/change", {subId: sub_id, firmId: firm_id, items: items});
}

function importApplicationById(firm_id, applId) {
  const request = createClient(token);
  return request.post("/publicapplication", { firm_id: firm_id, application_number: applId });
}

function downloadTmDoc(firm_id, serial_number, doc_id) {
  const request = createClient(token);
  return request.post("/trademark/download-doc", {
    firm_id: firm_id,
    serial_number: serial_number,
    doc_id: doc_id,
  });
}

export {
  setAuthToken,
  getUSPatentApplication,
  getIssuedPatentMaintenanceData,
  downloadDocument,
  getUSPatAppbyCustNum,
  getUSPatentApplicationCmsData,
  enqueuePrivatePair,
  enqueuePrivatePairPatent,
  getUSPatentApplicationIfwData,
  sendInvites,
  acceptInvite,
  countPendingPatents,
  sendXml,
  downloadDocumentByDownloadUrl,
  getReferencesAndCitations,
  generateClaimChart,
  getClaimChart,
  updateClaimChartRow,
  verifyClaimChartCitation,
  addLLM,
  deleteLLM,
  cancelSubscription,
  changeSubscription,
  draftOAResponse,
  streamOAAnalysis,
  oaChat,
  downloadReference,
  uploadReferencePdf,
  importApplicationById,
  parseIdsPdf,
  parseOaPdf,
  parseClaimsPdf,
  downloadIdsReference,
  parseRefPdfs,
  lookupReferences,
  downloadTmDoc,
};
